<script lang="ts">
    import {onMount} from "svelte";
    import {UrlUtil} from "../../../lib/Common/Http/UrlUtil";
    import HttpRequestOption from "../../../lib/Common/Http/HttpRequestOption";
    import {HttpRequestUtil} from "../../../lib/Common/Http/HttpRequestUtil";
    import LoadingContentView from "../../../component/common/Loading/LoadingContentView.svelte";
    import ArraySlotView from "../../../component/common/Value/ArraySlotView.svelte";
    import AdminSpaceUserAccessLogRowView from "./AdminSpaceUserAccessLogRowView.svelte";
    import HeadingTitleView from "../../../component/common/Typography/HeadingTitleView.svelte";


    let isLoading = false;
    let spaceUserAccessLogs = null;

    onMount(() => {
        loadData();
    });

    function loadData() {
        const params = {};


        const url = UrlUtil.createApiUrl("admin/space_user_access_log/dau", params);

        const option = HttpRequestOption.createForGet();
        isLoading = true;
        HttpRequestUtil.getRequest(url, (response) => {
            isLoading = false;
            const body = response['body'];
            console.log(body);

            spaceUserAccessLogs = body['space_user_access_logs'];


        }, option);
    }

</script>

<div class="admin-space-user-access-log-page standard-page">

    <div>
        <HeadingTitleView title="アクセスログ" backLinkUrl="/#/admin"/>
    </div>

    <div>
        <LoadingContentView isLoading={isLoading}>
            <ArraySlotView array={spaceUserAccessLogs}>
                <table class="standard-table">
                    <thead>
                    <tr>
                        <th>スペース名</th>
                        <th>ユーザー</th>
                        <th>アクセス</th>
                        <th>セッション</th>


                    </tr>
                    </thead>
                    <tbody>
                    {#each spaceUserAccessLogs as spaceUserAccessLog}
                        <AdminSpaceUserAccessLogRowView spaceUserAccessLog={spaceUserAccessLog}/>
                    {/each}


                    </tbody>
                </table>
            </ArraySlotView>
        </LoadingContentView>

    </div>


</div>
<style lang="scss">
    .admin-space-user-access-log-page {
        table {
            tbody {
                tr {
                    td {


                    }
                }
            }
        }
    }
</style>